export enum EHeaderTap {
  MATCH = 0,
  H2H = 1,
  CLASIFICACION = 2,
}

export enum EMatchTap {
  SUMMARY = 0,
  STATS = 1,
  LINEUP = 2,
  INFO_MATCH = 3,
}
